import request from '@/utils/request'

// 自动测试：所有，分页
export function autoTest(query) {
  return request({
    url: '/v1.0/iwrs/blind_test/automatic_test_all',
    method: 'get',
    params: query
  })
}

// 新增自动化测试
export function autoTestAdd(data) {
  return request({
    url: '/v1.0/iwrs/blind_test/automatic_test_add',
    method: 'post',
    data
  })
}

// 手动测试：所有，分页
export function manualTest(query) {
  return request({
    url: '/v1.0/iwrs/blind_test/manual_test_all',
    method: 'get',
    params: query
  })
}

// 清空
export function cleanData(data) {
  return request({
    url: '/v1.0/iwrs/blind_test/clean',
    method: 'post',
    data
  })
}

// 自动测试结果导出
export function exportTest(query) {
  return request({
    url: '/v1.0/iwrs/blind_test/export',
    method: 'get',
    responseType: 'blob',
    params: query
  })
}
